// Schemas
import { schema } from 'normalizr';

export const popup = new schema.Entity('popups');
export const popups = new schema.Array(popup);
